module.exports = __webpack_public_path__ + "static/media/WAP.7082f2eb.svg";